import tw from 'twin.macro';
import React from 'react';
import Select, { Value } from 'components/Form/Select2';

const tabItemStyle = tw`whitespace-nowrap flex py-2.5 px-2.5 border-b-2 font-medium text-sm relative justify-center`;
export const activeItemStyle = [
  tabItemStyle,
  tw`cursor-pointer border-brand-intense text-brand-intense`,
];
export const inactiveItemStyle = [
  tabItemStyle,
  tw`touch-none border-transparent text-neutral-quiet hover:border-neutral-quiet hover:text-neutral-moderate`,
];

export interface Tab<TId = string> {
  label: string;
  id: TId;
  current: boolean;
  disabled?: boolean;
}

interface Props<TId = string> {
  className?: string;
  noSelect?: boolean;
  display: 'grid' | 'flex' | 'flex-wrap' | 'flex-grow';
  onChange: (v: TId) => void;
  tabs: Tab<TId>[];
}

export function TabsWithUnderline<TId extends Value = string>(
  props: Props<TId>,
) {
  const { className, tabs, onChange, noSelect, display } = props;
  return (
    <div className={className}>
      {!noSelect && (
        <div tw="sm:hidden">
          <Select<TId>
            options={tabs.map(i => ({
              label: i.label,
              value: i.id,
            }))}
            value={tabs.find(tab => tab.current)?.id}
            onChange={id => onChange(id)}
          />
        </div>
      )}
      <div css={[!noSelect && tw`hidden sm:block`]}>
        <div tw="border-b border-neutral-quiet">
          <nav
            css={[
              tw`-mb-px`,
              (display === 'flex' || display === 'flex-grow') && tw`flex`,
              display === 'flex-wrap' && tw`flex flex-wrap gap-x-8`,
              display === 'grid' && tw`grid grid-flow-col auto-cols-fr`,
            ]}
            aria-label="Tabs"
          >
            {tabs.map(tab => (
              <button
                onClick={e => {
                  e.preventDefault();
                  onChange(tab.id);
                }}
                key={tab.id}
                css={[
                  tw`flex justify-center items-center disabled:text-neutral-supershy! disabled:border-transparent! disabled:cursor-not-allowed`,
                  display === 'flex-grow' && tw`flex-grow`,
                  tab.current ? activeItemStyle : inactiveItemStyle,
                ]}
                disabled={tab.disabled}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
